module["exports"] = [
  "#####"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/es_MX/address/postcode.js
 ** module id = 621
 ** module chunks = 0
 **/